The upper limit of webhook subscription replays to return from the end of the list.

Excess subscription replays will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
